import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import { fetchFeedbacks } from '../carporateServices/feedbackAndManagementListSlice';

export interface FeedbackComplaintsFormData {
  id?: string;
  date_of_feedback: string;
  feedback_provider_name: string;
  contact_info: string;
  type_of_feedback: string;
  description: string;
  action_taken?: string;
  resolved?: boolean;
  created_by: string;
  created_on: string;
}

interface ComplaintAndFeedbackState {
  message: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: ComplaintAndFeedbackState = {
  message: null,
  loading: false,
  error: null
};

export const submitComplaintAndFeedback = createAsyncThunk<
  { message: string },
  FeedbackComplaintsFormData,
  { rejectValue: string }
>('complaintAndFeedback/submit', async (formData, { rejectWithValue, dispatch }) => {
  try {
    const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
    };
    const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
      selectedServiceTitle?: string;
    };
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';

    if (!project.projectId || !service.selectedServiceTitle || !client_email) {
      return rejectWithValue('Missing project, service, or client information in localStorage');
    }

    const payload = {
      ...formData,
      group_id: project.projectId,
      service_name_id: service.selectedServiceTitle,
      client_email
    };

    const response = await axiosInstance.post('/ndis/form/complaints', payload);
    await dispatch(fetchFeedbacks({ client_email })).unwrap();
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to submit feedback');
  }
});

const complaintAndFeedbackSlice = createSlice({
  name: 'complaintAndFeedback',
  initialState,
  reducers: {
    clearComplaintAndFeedbackState: (state) => {
      state.message = null;
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitComplaintAndFeedback.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(submitComplaintAndFeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(submitComplaintAndFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.message = null;
      });
  }
});

export const { clearComplaintAndFeedbackState } = complaintAndFeedbackSlice.actions;
export default complaintAndFeedbackSlice.reducer;
